module.exports = __webpack_public_path__ + "img/enlightenment-course-6.6b8c1153.png";